/**
 * Defines all supported kinds of inspections than can be done at an aggregate.
 *
 * !!!
 * IMPORTANT: This enum is also defined in the following repositories: inspector-app, backoffice-backend => keep the versions synchronized
 * !!!
 */

export enum InspectionKind {
  HYGIENE_INSPECTION = 'HYGIENE_INSPECTION',
  ENERGETIC_INSPECTION = 'ENERGETIC_INSPECTION',
}
